import axios from "./api";
import myAxiosV2 from "./apiV2";

const base = "/admin/rbac/feature";
const rolesUserBase = "/business/attach-user-role";
const roleBase = "/admin/rbac/roles";

const RBAC = {
  getAll() {
    return axios.get(base);
  },
  deleteRoleForUser(user_id, role_id) {
    return axios.delete(
      `/admin/delete-user-role/${user_id}?role_id=${role_id}`
    );
  },
  add(body) {
    return axios.post(base, body);
  },
  update(id, body) {
    return axios.put(`${base}/${id}`, body);
  },
  addPermissionsRolesUser(body) {
    return axios.post(rolesUserBase, body);
  },
  addRole(body) {
    return axios.post(roleBase, body);
  },
  getRolesList() {
    return axios.get(roleBase);
  },
  getRoleById(id, body) {
    return axios.put(`${roleBase}/${id}`, body);
  },
  updateRoleName(id, name) {
    return myAxiosV2.put(`/admin/roles/${id}`, { name });
  },
  deleteRole(id) {
    return myAxiosV2.delete(`/admin/roles/${id}`);
  },
  updateAttachUserRole(body) {
    return axios.put(`/business/update-attach-user-role`, body);
  },
};

export default RBAC;
